import React from 'react'
import { Link } from 'react-router'
import styles from './Header.scss'
import { PublishDialog } from './PublishDialog'
import { Button } from 'common/Button'
import { Navbar, NavbarGroup, NavbarTitle } from 'common/Navbar'
import { Icon } from 'common/LegacyIcon'
import { DialogButton } from 'common/DialogButton'
import { Msg, useFormatMessage, featureNames, commonVerbs, commonMessages } from 'lib/localization'
import { FormattedMessage as T } from 'react-intl'

export const Header = ({ publishStatus, onStatusChange, onPublish,
  reportSlug, saveState, onDelete, onUndo, onRedo, hasUndo, hasRedo,
  repickRides, toggleMetric, metricUnits, showHints }) => {
  const fm = useFormatMessage()
  return <div className={styles.Header}>
    <Navbar>
      <NavbarGroup>
        <li><NavbarTitle to='/ride_reports'><Msg m={featureNames.rideReports} /></NavbarTitle></li>
        <li><Link to='/ride_reports/drafts'>
            &laquo; <T id='Header.backToDrafts' defaultMessage='back to drafts' />
        </Link></li>
        <li className={styles.saveStatus}>
          <SaveStatus saveState={saveState} />
        </li>
      </NavbarGroup>
      <NavbarGroup>
        <li className={styles.lessMargin}><Button type='default' onClick={onUndo} disabled={!hasUndo}>
          <T id='Header.undo' defaultMessage='undo' />
        </Button></li>
        <li className={styles.lessMargin}><Button type='default' onClick={onRedo} disabled={!hasRedo}>
          <T id='Header.redo' defaultMessage='redo' />
        </Button></li>
        <li className={styles.lessMargin}><DialogButton label={<T id='Header.publish' defaultMessage='publish' />}>
          <PublishDialog currentPublishStatus={publishStatus}
            onPublish={onPublish}
            reportSlug={reportSlug} />
        </DialogButton></li>
        <li className={styles.lessMargin}><DialogButton label={<Icon i='menu' size={13} />}>
          <ul className={styles.moreList}>
            <li><a href={`/ride_reports/${reportSlug}`} target='_blank'>
              {publishStatus === 'draft'
                ? <T id='Header.preview' defaultMessage='preview' />
                : <T id='Header.viewReport' defaultMessage='view report' />} &raquo;
            </a></li>
            <li onClick={repickRides}><a>
              <T id='Header.addRemove' defaultMessage='add/remove rides' />
            </a></li>
            <li onClick={showHints}><a>
              <T id='Header.showHints' defaultMessage='show hints' />
            </a></li>
            <li><a onClick={toggleMetric}>
              <T
                id='Header.metricToggle'
                defaultMessage='toggle metric ({value})'
                values={{ value: fm(metricUnits ? commonMessages.on : commonMessages.off) }}
              /></a></li>
            <li><a className={styles.delete} onClick={onDelete}><Msg lowerCase m={commonVerbs.delete} /></a></li>
          </ul>
        </DialogButton></li>
      </NavbarGroup>
    </Navbar>
  </div>
}

const SaveStatus = ({ saveState }) => {
  if (!saveState || !saveState.unsavedChanges) {
    return <span><T id='Header.allSaved' defaultMessage='All changes saved.' /></span>
  }
  if (saveState.saveFailed && !saveState.savePending) {
    return <span className={styles.errorMessage}><T id='Header.problemSaving' defaultMessage='We had a problem saving your report.' /></span>
  }
  return <span><Msg m={commonMessages.saving} />...</span>
}
